/** Calculate max width and height to respect the ratio */
var getSizeByRatio = function getSizeByRatio(width, height, ratio) {
  return {
    width: width > ratio * height ? height * ratio : width,
    height: width > ratio * height ? height : width / ratio
  };
};

export default getSizeByRatio;